import React from 'react';
import { SvgIcon, SvgIconProps } from '@mui/material';

export const IconSirenOn = (props: SvgIconProps) => {
  const { sx, ...other } = props;
  return (
    <SvgIcon
      xmlns="http://www.w3.org/2000/svg"
      width={24}
      height={25}
      fill="none"
      viewBox="0 0 24 25"
      preserveAspectRatio="xMidYMid meet"
      sx={{
        ...sx,
      }}
      {...other}
    >
      <g clipPath="url(#clip0_4904_59472)">
        <path
          d="M6.56704 4.13208C5.47941 4.73604 4.58293 5.63288 3.97942 6.72075"
          stroke="currentColor"
          strokeWidth="2"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M5.68809 1.23438C4.57186 1.55174 3.55524 2.14911 2.73475 2.96979C1.91426 3.79046 1.31712 4.80721 1 5.92352"
          stroke="currentColor"
          strokeWidth="2"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M4.14285 18.5201H19.8571"
          stroke="currentColor"
          strokeWidth="2"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M19.8571 18.5201C19.8571 18.5201 18.2857 17.1519 18.2857 12.2344C18.2857 8.30583 15.6017 4.82983 12 4.82983C8.39828 4.82983 5.71428 8.30583 5.71428 12.2344C5.71428 17.1781 4.14285 18.5201 4.14285 18.5201"
          fill="none"
          stroke="currentColor"
          strokeWidth="2"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M13.5714 21.663C13.5714 22.0797 13.4059 22.4794 13.1112 22.7741C12.8165 23.0688 12.4168 23.2344 12 23.2344C11.5832 23.2344 11.1835 23.0688 10.8888 22.7741C10.5941 22.4794 10.4286 22.0797 10.4286 21.663"
          stroke="currentColor"
          strokeWidth="2"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M12 4.82979V2.80579"
          stroke="currentColor"
          strokeWidth="2"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M17.433 4.13208C17.9732 4.43372 18.4696 4.80807 18.908 5.24465C19.3453 5.68288 19.7198 6.17964 20.0206 6.72075"
          stroke="currentColor"
          strokeWidth="2"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M18.3119 1.23438C19.4282 1.55174 20.4448 2.14911 21.2653 2.96979C22.0858 3.79046 22.6829 4.80721 23 5.92352"
          stroke="currentColor"
          strokeWidth="2"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </g>
    </SvgIcon>
  );
};
